import { mapWhenDefined } from '@essent/core-utils';
import {
  getError,
  getLoading,
  getPending,
  getStatus,
} from '@innogy/utils-state';
import { createSelector } from '@ngrx/store';
import type {
  ConsentGroupType,
  ConsentType,
} from '@integration/api-client/consent';

import {
  getConsent,
  getFlatGroupConsents,
} from '../../utils/get-consent.utils';
import { selectConsentState } from '../consent.state';

export const selectGetConsentsState = createSelector(
  selectConsentState,
  (state) => state.consentGroups
);

export const selectGetConsentsStatus = createSelector(
  selectGetConsentsState,
  getStatus
);

export const selectGetConsentsPending = createSelector(
  selectGetConsentsStatus,
  getPending
);

export const selectGetConsentsHasError = createSelector(
  selectGetConsentsStatus,
  getError
);

export const selectGetConsentsIsLoading = createSelector(
  selectGetConsentsStatus,
  getLoading
);

export const selectGetConsentsData = createSelector(
  selectGetConsentsState,
  (state) => state.data
);

export const selectGetConsentsGroup = (consentGroupType: ConsentGroupType) =>
  createSelector(selectGetConsentsData, (data) =>
    mapWhenDefined(data, (consentGroups) =>
      consentGroups.find(
        (consentGroup) => consentGroup.type === consentGroupType
      )
    )
  );

export const selectShouldInform = (consentGroupType: ConsentGroupType) =>
  createSelector(selectGetConsentsGroup(consentGroupType), (data) =>
    mapWhenDefined(data, (consentGroups) =>
      getFlatGroupConsents(consentGroups).some(
        (consent) => consent.inform === true
      )
    )
  );

export const selectGetConsent = (consentType: ConsentType) =>
  createSelector(selectGetConsentsData, (data) =>
    mapWhenDefined(data, (consentGroups) =>
      getConsent(consentGroups, consentType)
    )
  );

export const selectConsentVersionId = (consentType: ConsentType) =>
  createSelector(selectGetConsentsData, (data) =>
    mapWhenDefined(
      data,
      (consentGroups) =>
        getConsent(consentGroups, consentType)?.version_id ?? null
    )
  );
